"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrashType = void 0;
var CrashType;
(function (CrashType) {
    CrashType["vehicleToBicycle"] = "vehicleToBicycle";
    CrashType["bicycleToBicycle"] = "bicycleToBicycle";
    CrashType["bicycleToPedestrian"] = "bicycleToPedestrian";
    CrashType["singleBicycle"] = "singleBicycle";
})(CrashType || (exports.CrashType = CrashType = {}));
